<template>
    <div class="table-responsive mb-0">
        <table class="table table-sm table-hovered">
            <tr v-for="param in value" :key="param.Id">
                <th class="bg-light w-50">{{param.Key}}</th>
                <td class="w-50"><input v-model="param.Value" class="form-control form-control-sm" :placeholder="param.Key"/></td>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
    props:{
        value:Array
    },
        
}
</script>

<style>

</style>